<template>
  <cumulus-info-dialog
    v-model="dialogInfo"
    icon="$info"
    :title="$t(title)"
    :color="color"
    avatar
    activator-link
    custom-class="ml-6 ml-sm-1 d-inline-block"
    :max-width="800"
    @escape="closeDialog"
  >
    <template v-slot:info>
      <v-skeleton-loader
        v-if="!aszfData"
        type="article"
      />
      <v-container v-else>
        <v-card-text class="pa-4 help" v-html="aszfData" />
        <v-btn
          color="primary"
          class="ma-2"
          @click="getReport({ type: 'aszf-pdf'})"
        >
          {{ $t('download_pdf') }}
        </v-btn>
      </v-container>
    </template>
  </cumulus-info-dialog>
</template>

<script>

  import { call } from 'vuex-pathify'

  export default {
    name: 'Aszf',
    props: {
      title: {
        type: String,
        default: 'terms_and_conditions',
      },
      color: {
        type: String,
        default: 'secondary',
      },
    },
    data () {
      return {
        aszfData: null,
        dialogInfo: false,
        loading: false,
      }
    },
    computed: {
    },
    watch: {
      dialogInfo (val) {
        val || this.closeDialog()
        if (this.dialogInfo) {
          this.loadPage()
        }
      },
    },
    mounted () {
    },
    methods: {
      getAszf: call('report/aszf'),
      getReport: call('action/getReport'),
      async loadPage () {
        this.loading = true
        try {
          await this.getAszf({
          }).then(response => {
            this.loading = false
            this.aszfData = response
          }).catch(e => {
            console.log(e)
          })
        } catch (e) {
          alert(e)
        }
      },
      closeDialog () {
        this.aszfData = null
        this.dialogInfo = false
      },
    },
  }
</script>

<style lang="sass">
.v-dialog
  .v-card
    display: flex !important
    flex-direction: column

  .v-card__text
    flex-grow: 1
    overflow: auto
// max-height: calc(100vh - 500px)
.help div
  margin-top: 4px
  margin-bottom: 4px

.teszt
  background-color: #00b0ff

.chapter-header
  color: white
  justify-content: center
  background-color: darkgray
  min-height: 50px
  padding: 20px 0
  border: 3px solid darkgray
  text-align: center

h1,h2
  text-align: center
  padding: 10px

.functions
  h3
    padding: 3px 0px 3px
    margin: 0px
  p
    padding: 1px
    margin: 1px

.table-solid
  border-collapse: collapse !important
  width: 100%
  th, td
    border: 1px solid black
    padding: 3px

</style>
